import WidgetModule from "@eisinc/Overrides/Widgets/Common/ProductCarousel";

export * from "@eisinc/Overrides/Widgets/Common/ProductCarousel";

export default WidgetModule;
